<script lang="ts">
import { defineComponent } from 'vue'
import { RouterLink } from 'vue-router'

export default defineComponent({
  components: { RouterLink },
  props: {
    to: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
})
</script>

<template>
  <RouterLink
    :to="to"
    class="flex flex-row items-center @md/main:items-start gap-x-2 rounded-lg border border-slate-300 bg-pure-white p-3 text-black transition-all duration-200 ease-in-out hover:shadow-lg md:flex-col md:p-6"
  >
    <AppIcon v-if="icon" :icon="icon" size="md" class="flex-shrink-0" />
    <p class="font-bold capitalize truncate" :class="icon ? 'md:mt-2' : ''">
      {{ title }}

      <span v-if="subtitle" class="max-sm:text-xs"> <br />{{ subtitle }} </span>
    </p>

    <AppIcon
      :icon="Icons.AccordionArrow"
      class="ml-auto -rotate-90 md:hidden"
    />
  </RouterLink>
</template>
